import React, { Component, Fragment, lazy, Suspense, useContext, useEffect, useRef } from "react";
import { Route, Routes } from "react-router-dom";
import AuthContext from "../Hooks/AuthContext/AuthContext";
import AdminDashboardLayout from "../Layouts/AdminDashboardLayout";
import SuspenseScreen from "./SuspenseScreen";
import { Navigate } from "react-router-dom";
import PagesLayout from "../Layouts/PagesLayout";

const Router = () => {
  const { auth, init } = useContext(AuthContext);
  const storedToken = localStorage.getItem("token");
  const storedRole = localStorage.getItem("role");
  const isSignedIn = Boolean(auth?.is_logged_in || storedToken);
  const activeRole = auth?.role || storedRole;
  const homePath = isSignedIn
    ? (activeRole === "chairman" ? "/chairman/dashboard" : activeRole === "agent" ? "/admin/agent-dashboard" : activeRole === "staff" ? "/staff/payslips" : "/admin")
    : "/login";
  const routes: any = [
    {
      path: "/signUp",
      element: lazy(() => import("../Pages/SignUp")),
    },

    {
      path: "/admin/*",
      layout: AdminDashboardLayout,
      element: lazy(() => import("../Layouts/AdminDashboardLayout")),
      subRoutes: [
        {
          path: "",

          element: lazy(() => import("../Pages/Dashboard")),
        },
        {
          path: "resumes",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Resumes")),
        },
        {
          path: "countries",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Countries")),
        },
        {
          path: "no_passports",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/NoPassport")),
        },
        {
          path: "recruitments",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Recruitments")),
        },
        {
          path: "registrations",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Registrations")),
        },
        {
          path: "tickets",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Tickets")),
        },
        {
          path: "complaints",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Complaints")),
        },
        {
          path: "finance-management",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/FinanceManagement")),
        },
        {
          path: "financial-reports",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/FinancialReports")),
        },
        {
          path: "complaint-reports",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/ComplaintReports")),
        },
        {
          path: "countryProcess",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/CountryProcess")),
        },
        {
          path: "countryTemplate",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/CountryTemplate")),
        },

        {
          path: "jobTitles",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/JobTitles")),
        },
        {
          path: "processes",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Processes")),
        },
        {
          path: "process-view",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/ProcessView")),
        },
        {
          path: "skills",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Skills")),
        },
        {
          path: "resume-view/:id",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/ResumeView")),
        },
        {
          path: "subAgent",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/SubAgent")),
        },
        {
          path: "staff",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Staff")),
        },
        {
          path: "salary-management",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/SalaryManagement")),
        },
        {
          path: "hr-reports",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/HRReports")),
        },
        {
          path: "activity-report",
          element: lazy(() => import("../Pages/ActivityReport")),
        },
        {
          path: "login-report",
          element: lazy(() => import("../Pages/LoginReport")),
        },
        {
          path: "eventLog",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/EventLog")),
        },
        {
          path: "pdf",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/PDFDocument")),
        },
        {
          path: "passports",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Passports")),
        },
        {
          path: "country-agents",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/CountryAgents")),
        },
        {
          path: "medical-centres",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/MedicalCentres")),
        },
        {
          path: "training-centres",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/TrainingCentres")),
        },
        {
          path: "ticket-agents",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/TicketAgents")),
        },
        {
          path: "agent-dashboard",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/AgentPortal/AgentDashboard")),
        },
        {
          path: "agent-change-password",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/AgentPortal/AgentChangePasswordPage")),
        },
        {
          path: "agent-cv-assignments",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/AgentPortal/AgentCVAssignmentsPage")),
        },
        {
          path: "agent-cv-assignments/:assignmentId",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/AgentPortal/AgentCVAssignmentsPage")),
        },
        {
          path: "staff-performance",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/StaffPerformance")),
        },
      ],
    },
    {
      path: "/login",
      element: lazy(() => import("../Pages/Login")),
    },
    {
      path: "/agent/login",
      element: lazy(() => import("../Pages/AgentPortal/AgentLoginPage")),
    },
    {
      path: "/agent/forgot-password",
      element: lazy(() => import("../Pages/AgentPortal/AgentForgotPasswordPage")),
    },
    {
      path: "/agent/reset-password",
      element: lazy(() => import("../Pages/AgentPortal/AgentResetPasswordPage")),
    },
    {
      path: "/staff/login",
      element: lazy(() => import("../Pages/StaffLogin")),
    },
    {
      path: "/staff/payslips",
      element: lazy(() => import("../Pages/StaffPayslips")),
    },
    {
      path: "/chairman/dashboard",
      element: lazy(() => import("../Pages/ChairmanDashboard")),
    },
    {
      path: "/candidate/login",
      element: lazy(() => import("../Pages/CandidatePortal/CandidateLoginPage")),
    },
    {
      path: "/candidate/dashboard",
      element: lazy(() => import("../Pages/CandidatePortal/CandidateDashboard")),
    },
  ];

  class RouteErrorBoundary extends Component<
    { children: React.ReactNode },
    { hasError: boolean; error: any }
  > {
    constructor(props: { children: React.ReactNode }) {
      super(props);
      this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error: any) {
      return { hasError: true, error };
    }
    componentDidCatch(error: any, errorInfo: any) {
      console.error("Router error boundary caught:", error, errorInfo);
    }
    render() {
      if (this.state.hasError) {
        return (
          <div style={{ padding: 24, margin: 16, background: "#fee2e2", border: "1px solid #ef4444", borderRadius: 8 }}>
            <h3 style={{ color: "#991b1b", margin: "0 0 8px 0" }}>Page Loading Error</h3>
            <p style={{ color: "#b91c1c", margin: 0 }}>
              {String(this.state.error?.message || this.state.error || "An unexpected error occurred.")}
            </p>
            <button
              style={{ marginTop: 12, padding: "8px 16px", background: "#4A1D96", color: "#fff", border: "none", borderRadius: 4, cursor: "pointer" }}
              onClick={() => window.location.reload()}
            >
              Reload Page
            </button>
          </div>
        );
      }
      return this.props.children;
    }
  }

  const RouteRender = (route: any, i: number) => {
    const Element = route.element ? route.element : Fragment;
    const Layout = route.layout ? route.layout : Fragment;

    return (
      <Route
        key={i}
        index={route.path ? false : true}
        path={route.path}
        element={
          <Layout>
            <Suspense fallback={<SuspenseScreen />}>
              {route.subRoutes ? (
                <Routes>
                  {route.subRoutes.map((subRoute: any, index: any) => {
                    const SubElement = subRoute.element;
                    const SubLayout = subRoute.layout
                      ? subRoute.layout
                      : Fragment;

                    return (
                      <Route
                        path={subRoute.path}
                        element={
                          <SubLayout>
                            <Suspense fallback={<SuspenseScreen />}>
                              <RouteErrorBoundary>
                                <SubElement />
                              </RouteErrorBoundary>
                            </Suspense>
                          </SubLayout>
                        }
                        key={"admin" + index}
                      />
                    );
                  })}
                </Routes>
              ) : (
                <RouteErrorBoundary>
                  <Element />
                </RouteErrorBoundary>
              )}
            </Suspense>
          </Layout>
        }
      ></Route>
    );
  };

  const initRef = useRef(init);
  useEffect(() => { initRef.current = init; }, [init]);
  useEffect(() => { initRef.current(); }, []);
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to={homePath} replace />} />
        {routes.map(RouteRender)}
        <Route path="*" element={<Navigate to={homePath} replace />} />
      </Routes>
    </>
  );
};

export default Router;
